export class RolesResource{
  id: number;
  description: string;
}
